import { render, staticRenderFns } from "./tongji-result.vue?vue&type=template&id=4786d345&scoped=true&"
import script from "./tongji-result.vue?vue&type=script&lang=ts&"
export * from "./tongji-result.vue?vue&type=script&lang=ts&"
import style0 from "./tongji-result.vue?vue&type=style&index=0&id=4786d345&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4786d345",
  null
  
)

export default component.exports